import React from "react";
import { useTranslation } from "react-i18next";
import { Globe } from "lucide-react";
import { languageMeta } from "@/lib/i18n.config";

const languages = languageMeta;

export function LanguageSwitcher() {
  const { i18n } = useTranslation();

  const currentCode = String(i18n.resolvedLanguage || i18n.language || "en").split("-")[0];
  const currentLang = languages.find((lang) => lang.code === currentCode) || languages[0];
  const nextLang = languages.find((lang) => lang.code !== currentLang.code) || languages[0];

  const toggleLanguage = () => {
    // Reloads already-loaded namespaces for the next language (core + any feature ns).
    void i18n.changeLanguage(nextLang.code);
  };

  return (
    <button
      type="button"
      className="inline-flex h-[var(--ds-density-control-height)] cursor-pointer items-center gap-2 rounded-[var(--ds-radius-control)] border border-sidebar-border bg-sidebar px-2 text-sm text-sidebar-foreground outline-none transition-colors hover:border-sidebar-active-border hover:bg-sidebar-accent focus-visible:ring-2 focus-visible:ring-sidebar-ring motion-reduce:transition-none"
      onClick={toggleLanguage}
      aria-label={nextLang.name}
      title={nextLang.name}
    >
      <Globe className="h-4 w-4" />
      <span className="font-semibold tracking-wide">
        {currentLang.code.toUpperCase()}
      </span>
    </button>
  );
}
